<template>
  <div class="hp-header-logo d-flex align-items-center">
    <b-link to="/" class="position-relative d-flex">
      <img
        class="hp-logo"
        v-bind:src="require('@/assets/img/logo/logo.svg')"
        alt="logo"
      />
    </b-link>

    <a
      href="https://hypeople-studio.gitbook.io/yoda/change-log"
      target="_blank"
      class="hp-caption font-weight-normal hp-text-color-primary-1"
    >
      {{ version }}
    </a>
  </div>
</template>

<script>
import { BLink } from "bootstrap-vue";

export default {
  data() {
    return {
      version: process.env.VUE_APP_VERSION
    }
  },
  components: {
    BLink,
  },
};
</script>
